(function () {
  document.querySelectorAll('[data-collection-tabs]').forEach(function (section) {
    var tabs = Array.from(section.querySelectorAll('.collection-tabs__tab'));
    var storageKey = 'collection-tabs-active-' + section.dataset.collectionTabs;
    var switchBannerImage = section.dataset.switchBannerImage === 'true' || section.dataset.switchBannerImage === '1';
    var switchBannerText = section.dataset.switchBannerText === 'true' || section.dataset.switchBannerText === '1';
    var defaultBannerState = null;

    function setActiveTab(activeTab) {
      tabs.forEach(function (tab) {
        tab.classList.remove('is-active');
        tab.setAttribute('aria-selected', 'false');
      });
      activeTab.classList.add('is-active');
      activeTab.setAttribute('aria-selected', 'true');
    }

    function buildUrl(baseUrl) {
      var sortBy = new URLSearchParams(window.location.search).get('sort_by');
      if (!sortBy) return baseUrl;
      var url = new URL(baseUrl, window.location.origin);
      url.searchParams.set('sort_by', sortBy);
      return url.pathname + url.search;
    }

    function fireTabChanged(urlWithParams, collectionHandle) {
      document.dispatchEvent(new CustomEvent('collection-tabs:changed', {
        bubbles: true,
        detail: { url: urlWithParams, handle: collectionHandle }
      }));
    }

    function updateBannerFromTab(tab) {
      if (!switchBannerImage && !switchBannerText) return;

      var bannerSection = document.querySelector('.shopify-section--collection-banner');
      if (!bannerSection) return;

      if (!defaultBannerState) {
        var defaultPicture = bannerSection.querySelector('.content-over-media picture');
        var defaultImg = defaultPicture ? defaultPicture.querySelector('img') : null;
        var defaultHeadingEl = bannerSection.querySelector('.collection-banner-tabs__heading, .prose.text-center .h1, .prose.text-center h1');

        defaultBannerState = {
          imgSrc: defaultImg ? defaultImg.getAttribute('src') || '' : '',
          imgSrcset: defaultImg ? defaultImg.getAttribute('srcset') || '' : '',
          sourceSrcsets: defaultPicture ? Array.from(defaultPicture.querySelectorAll('source')).map(function (source) {
            return source.getAttribute('srcset') || '';
          }) : [],
          headingHtml: defaultHeadingEl ? defaultHeadingEl.innerHTML : ''
        };
      }

      if (switchBannerImage) {
        var imageUrl = tab.dataset.bannerImageUrl;
        var picture = bannerSection.querySelector('.content-over-media picture');
        var img = picture ? picture.querySelector('img') : null;
        if (img && picture) {
          if (imageUrl) {
            img.setAttribute('src', imageUrl);
            img.setAttribute('srcset', imageUrl);

            var sources = picture.querySelectorAll('source');
            sources.forEach(function (source) {
              source.setAttribute('srcset', imageUrl);
            });
          } else if (defaultBannerState) {
            img.setAttribute('src', defaultBannerState.imgSrc);
            img.setAttribute('srcset', defaultBannerState.imgSrcset);

            var defaultSources = picture.querySelectorAll('source');
            defaultSources.forEach(function (source, index) {
              source.setAttribute('srcset', defaultBannerState.sourceSrcsets[index] || '');
            });
          }
        }
      }

      if (switchBannerText) {
        var bannerContent = tab.dataset.bannerContent;
        var bannerHeading = bannerSection.querySelector('.collection-banner-tabs__heading, .prose.text-center .h1, .prose.text-center h1');
        if (bannerHeading) {
          if (bannerContent) {
            bannerHeading.innerHTML = bannerContent;
          } else if (defaultBannerState) {
            bannerHeading.innerHTML = defaultBannerState.headingHtml;
          }
        }
      }
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var collectionUrl = this.dataset.collectionUrl;
        var collectionHandle = this.dataset.collectionHandle;

        if (!collectionUrl || this.classList.contains('is-active')) return;

        setActiveTab(this);
        sessionStorage.setItem(storageKey, collectionHandle);
        updateBannerFromTab(this);

        fireTabChanged(buildUrl(collectionUrl), collectionHandle);
      });
    });

    // Restore last active tab on page load
    var savedHandle = sessionStorage.getItem(storageKey);
    if (savedHandle) {
      var savedTab = tabs.find(function (tab) {
        return tab.dataset.collectionHandle === savedHandle;
      });
      if (savedTab && !savedTab.classList.contains('is-active')) {
        document.documentElement.setAttribute('data-tabs-restoring', '');
        setActiveTab(savedTab);
        updateBannerFromTab(savedTab);
        fireTabChanged(buildUrl(savedTab.dataset.collectionUrl), savedHandle);
      } else {
        document.documentElement.removeAttribute('data-tabs-restoring');
      }
    } else {
      document.documentElement.removeAttribute('data-tabs-restoring');
    }

    // Apply current active tab values for banner on initial load.
    var currentActiveTab = tabs.find(function (tab) { return tab.classList.contains('is-active'); });
    if (currentActiveTab) {
      updateBannerFromTab(currentActiveTab);
    }
  });

  // Sync collection-desktop-layout attribute → class on product-list
  var productList = document.querySelector('.product-list');
  if (productList) {
    function syncLayoutClass(el) {
      var layout = el.getAttribute('collection-desktop-layout');
      el.classList.remove('is-layout-compact', 'is-layout-medium', 'is-layout-large');
      if (layout) el.classList.add('is-layout-' + layout);
    }
    syncLayoutClass(productList);
    new MutationObserver(function() { syncLayoutClass(productList); })
      .observe(productList, { attributes: true, attributeFilter: ['collection-desktop-layout'] });
  }
})();
